var map = {
	"./allbet.png": 2920,
	"./asiagaming.png": 6259,
	"./bbin.png": 3967,
	"./cq9.png": 6453,
	"./evolution.png": 2767,
	"./fbsports (1).png": 6825,
	"./fbsports.png": 2091,
	"./gameplay.png": 5162,
	"./jdb.png": 9928,
	"./jili.png": 5504,
	"./joker.png": 9101,
	"./lgd.png": 2453,
	"./live22.png": 6812,
	"./maxbet.png": 8513,
	"./mega888.png": 330,
	"./megah5.png": 4965,
	"./microgaming.png": 6539,
	"./netent.png": 8678,
	"./playngo.png": 9422,
	"./playstar.png": 3544,
	"./playtech.png": 1120,
	"./pragmaticplay.png": 2622,
	"./pussy888.png": 6,
	"./qtech.png": 4105,
	"./spadegaming.png": 672,
	"./spinomenal.png": 6160,
	"./uuslots.png": 9037,
	"./wbet.png": 9662,
	"./wmcasino.png": 9471,
	"./worldentertainment.png": 4288,
	"./worldmatch.png": 6153,
	"./xe88.png": 3131,
	"assets/images/providers/allbet.png": 2920,
	"assets/images/providers/asiagaming.png": 6259,
	"assets/images/providers/bbin.png": 3967,
	"assets/images/providers/cq9.png": 6453,
	"assets/images/providers/evolution.png": 2767,
	"assets/images/providers/fbsports (1).png": 6825,
	"assets/images/providers/fbsports.png": 2091,
	"assets/images/providers/gameplay.png": 5162,
	"assets/images/providers/jdb.png": 9928,
	"assets/images/providers/jili.png": 5504,
	"assets/images/providers/joker.png": 9101,
	"assets/images/providers/lgd.png": 2453,
	"assets/images/providers/live22.png": 6812,
	"assets/images/providers/maxbet.png": 8513,
	"assets/images/providers/mega888.png": 330,
	"assets/images/providers/megah5.png": 4965,
	"assets/images/providers/microgaming.png": 6539,
	"assets/images/providers/netent.png": 8678,
	"assets/images/providers/playngo.png": 9422,
	"assets/images/providers/playstar.png": 3544,
	"assets/images/providers/playtech.png": 1120,
	"assets/images/providers/pragmaticplay.png": 2622,
	"assets/images/providers/pussy888.png": 6,
	"assets/images/providers/qtech.png": 4105,
	"assets/images/providers/spadegaming.png": 672,
	"assets/images/providers/spinomenal.png": 6160,
	"assets/images/providers/uuslots.png": 9037,
	"assets/images/providers/wbet.png": 9662,
	"assets/images/providers/wmcasino.png": 9471,
	"assets/images/providers/worldentertainment.png": 4288,
	"assets/images/providers/worldmatch.png": 6153,
	"assets/images/providers/xe88.png": 3131
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8385;